import { useGetList } from "ra-core";

import type { Sale } from "../types";

/** Active users, alphabetically. */
export const useActiveSales = () =>
  useGetList<Sale>("sales", {
    pagination: { page: 1, perPage: 1000 },
    sort: { field: "first_name", order: "ASC" },
    filter: { "disabled@neq": true },
  }).data ?? [];

export const getSaleName = (sale?: Pick<Sale, "first_name" | "last_name">) =>
  sale ? `${sale.first_name} ${sale.last_name}`.trim() : "";
